import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
export function AboutPage() {
  return <div className="bg-black min-h-screen" data-id="element-256">
      <Navigation data-id="element-257" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-259">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-260">
            About <span className="text-[#00D4FF]" data-id="element-261">Walker's</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-262">
            More than just a martial arts school. We are a community dedicated
            to empowering individuals through discipline, respect, and strength.
          </p>
        </motion.div>
      </div>

      {/* Our Story */}
      <section className="py-20 bg-[#111]" data-id="element-263">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-265">
            <div className="relative" data-id="element-266">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#00D4FF]/20 rounded-full blur-2xl" data-id="element-267" />
              <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?q=80&w=2072&auto=format&fit=crop" alt="Master Walker teaching" className="relative rounded-2xl shadow-2xl z-10" data-id="element-268" />
              <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-[#00D4FF]/30 rounded-2xl z-0" data-id="element-269" />
            </div>

            <div data-id="element-270">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-271">Our Story</h2>
              <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-272">
                <p data-id="element-273">
                  Founded in 1999, Walker's Martial Arts began with a simple
                  mission: to create a space where anyone, regardless of age or
                  ability, could discover their inner strength.
                </p>
                <p data-id="element-274">
                  Master Walker, a 6th Degree Black Belt, built this academy on
                  the principles of traditional martial arts while adapting to
                  the needs of modern families. What started as a small studio
                  has grown into Bloomington's premier martial arts facility.
                </p>
                <p data-id="element-275">
                  Today, we are proud to have served over 5,000 families in our
                  community, helping students build confidence, discipline, and
                  physical fitness that lasts a lifetime.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-black" data-id="element-276">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
          <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-278">
            Our Core Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-279">
            {[{
            title: 'Respect',
            desc: 'For ourselves, our instructors, and our community.'
          }, {
            title: 'Discipline',
            desc: 'The bridge between goals and accomplishment.'
          }, {
            title: 'Perseverance',
            desc: 'The strength to keep going when things get tough.'
          }].map((value, index) => <motion.div key={value.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-[#1a1a1a] p-8 rounded-2xl text-center border border-gray-800 hover:border-[#00D4FF] transition-colors" data-id="element-280">
                <h3 className="text-2xl font-bold text-[#00D4FF] mb-4" data-id="element-281">
                  {value.title}
                </h3>
                <p className="text-gray-300" data-id="element-282">{value.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-283" />
      <Footer data-id="element-284" />
    </div>;
}